// TEMPORARY (owner order 2026-10-22): hide every user-facing Discord mention, link and card until a payment processor approves Goonru.
// Processors (CCBill, Epoch) refuse anything that incorporates Discord into the paid service, so nothing in the app should look as if
// Discord is part of what members pay for. Set to true to bring the Discord links, cards and wording back. This does NOT touch the
// backend (role sync, XP) or users' own profile social links.
export const SHOW_DISCORD = false
